const RANK_ITEMS = [
  { rank: 1, title: '星际穿越', type: '科幻', score: '9.4', tag: '诺兰神作', hot: '本周播放 128,600 次' },
  { rank: 2, title: '肖申克的救赎', type: '剧情', score: '9.7', tag: '经典必看', hot: '本周播放 115,200 次' },
  { rank: 3, title: '盗梦空间', type: '科幻', score: '9.3', tag: '烧脑巨制', hot: '本周播放 98,700 次' },
  { rank: 4, title: '功夫', type: '动作', score: '8.8', tag: '周星驰经典', hot: '本周播放 87,400 次' },
  { rank: 5, title: '让子弹飞', type: '剧情', score: '9.0', tag: '国产巅峰', hot: '本周播放 76,100 次' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            热门排行
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            本周最受欢迎的影片，看看大家都在看什么
          </p>
        </div>

        <div className="space-y-3" data-product-shop="">
          {RANK_ITEMS.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 p-4 md:p-5 bg-background-200/40 rounded-lg border border-background-300/20 hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
            >
              {/* Rank number */}
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full font-heading font-bold text-lg flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-950'
                  : 'bg-background-300/40 text-foreground-400'
              }`}>
                {item.rank}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-1">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-accent-100/20 text-accent-400 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs md:text-sm text-foreground-500">
                  <span>{item.type}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
                  <span>{item.hot}</span>
                </div>
              </div>

              {/* Score */}
              <div className="text-right flex-shrink-0">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">{item.score}</div>
                <div className="text-xs text-foreground-600">豆瓣评分</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}